import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { IConfig } from './interfaces/config.interface';
import { NotificationsService } from './services/notifications.service';
import { StateService } from './services/state.service';
import { NotificationType } from './interfaces/notification.interface';
import { CreditAppService } from './services/credit-app.service';
import { TealiumService } from './services/tealium.service';
import { FormInfoService } from './services/form-info.service';
import { FormInfoBuynowService } from './services/form-info-buynow.service';
import { PreQualLeadInfo } from './interfaces/credit-application-config.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dt-an-prequalification-lib',
  template: `
    <div id="pricebreakdownModal" class="d-print-none" [ngClass]="{ 'legacyPriceModal': this.config.Sitecore.isLegacyCreditApp}" *ngIf="!config.Sitecore.IsContactStore">
    <price-details-lib></price-details-lib>
    </div>
    <dt-prequal class="dt-bootstrap" *ngIf="!config.Sitecore.IsContactStore && config.Sitecore.IsPrequalification && !config.Sitecore.apiDomain"></dt-prequal>
    <dt-prequal-modal class="dt-bootstrap" *ngIf="!config.Sitecore.IsContactStore && config.Sitecore.IsPrequalification && config.Sitecore.apiDomain"></dt-prequal-modal>
     <dt-contact-store class="dt-bootstrap" *ngIf="config.Sitecore.IsContactStore"></dt-contact-store>
  `,
  styles: [],
  standalone: false
})
export class DtAnCreditapplicationLibComponent implements OnInit {

  preQualLeadInfo: PreQualLeadInfo;
  constructor(
    private notifications: NotificationsService,
    @Inject('config') public config: IConfig,
    private stateService: StateService,
    private creditApp: CreditAppService,
    private tealiumService: TealiumService,
    /* tslint:disable:no-unused-variable */
    private formInfoService: FormInfoService,
    /* tslint:disable:no-unused-variable */
    private formInfoBuynowService: FormInfoBuynowService,
  ) {
    this.config.Sitecore = this.stateService.get('Sitecore');
    console.log('@@@ Config Loaded @@@', this.config.Sitecore);
    this.initilize();
  }

  initilize() {
    /* istanbul ignore else */
    if (this.config.Sitecore && this.config.Sitecore.CreditApplication) {
      this.creditApp.CreditApplication = this.config.Sitecore.CreditApplication;
    }

    if (this.config.Sitecore && this.config.Sitecore.TealiumSettings) {
      const tealiumAccount = this.config.Sitecore.TealiumSettings.TealiumAccount;
      const tealiumProfile = this.config.Sitecore.TealiumSettings.TealiumProfile;
      const tealiumEnv = this.config.Sitecore.TealiumSettings.TealiumENV;

      if (tealiumAccount && tealiumProfile && tealiumEnv) {
        this.tealiumService.setConfig({
          account: tealiumAccount,
          profile: tealiumProfile,
          environment: tealiumEnv
        });
      }
    }


    this.notifications.broadcastNotification({
      Message: 'Application initiliazed',
      Type: NotificationType.information,
      Payload: {
        Config: this.config
      }
    });

  }
  ngOnInit() {
    this.preQualLeadInfo = this.config?.Sitecore?.PreQualLeadInfo;
  }

  @HostListener('window:message', ['$event'])
  onMessage(event) {
    try {
      /* istanbul ignore next */
      if (event.data.type === 'priceDetailsModal') {

          let apiDomain = this.config.Sitecore.apiDomain ? this.config.Sitecore.apiDomain.replace('/pre-qualification','') : '';
          const request = {
            Source: 'My-Garage',
            ReqData: {
              Vin: this.preQualLeadInfo?.vin || this.config?.Sitecore?.leftRailVehicleData?.Vin,
              StockType: this.preQualLeadInfo?.inventoryType?.toLowerCase() || "new",
              PriceType: this.preQualLeadInfo?.email ? "unlock" : "lock",
              StoreZipCode: this.config?.Sitecore?.StoreInfo?.Address?.PostalCode,
              ZipCode: this.preQualLeadInfo?.zipcode,
              HyperionId: this.preQualLeadInfo?.HyperianId,
              ViewNames: "Detailed",
              StateCode: this.config?.Sitecore?.StoreInfo?.Address?.StateCode
            },
            apiDomain: apiDomain
          }
          document.dispatchEvent(
            new CustomEvent("__OPEN__PRICE__BREAKDOWN__MODAL__", {
              detail: request,
            })
          );

      }
    } catch (e) {
      /* istanbul ignore next */
      console.log(e);
    }
  }

}

